import { Directive, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { OgImageService, OgImage } from '../providers/og-image.service';
import { BaseImageAttributes } from '../types/image';

@Directive({
  selector: '[appOgImage]',
  standalone: true,
})
export class OgImageDirective implements OnInit, OnDestroy {

  @Input() public appOgImage!: BaseImageAttributes;

  private ogImageService = inject(OgImageService);
  private ogImage?: OgImage;

  public ngOnInit(): void {
    this.ogImage = this.ogImageService.add(this.appOgImage.src, this.appOgImage.alt);
  }

  public ngOnDestroy(): void {
    if (this.ogImage) {
      this.ogImageService.remove(this.ogImage);
    }
  }

}
